import {
  collection,
  doc,
  getDocs,
  orderBy,
  query,
  where,
} from "firebase/firestore";
import { db } from "../../firebase";
import { getLocalStorageItem } from "../localStorage/getLocalStorage";

const GetLogVisitors = async (propertyId) => {
  /**
   * input: null
   * output: log visitor object
   * description: fetches all visitors
   */
  try {
    const visitorCollection = query(
      collection(db, "visits"),
      // where("bid", "==", getLocalStorageItem("bid")),
      where("propertyId", "==", propertyId),
      // orderBy("createdAt", "desc")
    );

    const logVisitorSnapshot = await getDocs(visitorCollection);
    let logVisitors = [];
    logVisitorSnapshot.forEach((visitor) =>
      logVisitors.push({ id: visitor.id, ...visitor.data() })
    );

    return logVisitors;
  } catch (error) {
    console.log(error);
  }
};

export default GetLogVisitors;
